/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inquiryAdminControllerAnswerV1 } from '../fn/inquiry-admin/inquiry-admin-controller-answer-v-1';
import { InquiryAdminControllerAnswerV1$Params } from '../fn/inquiry-admin/inquiry-admin-controller-answer-v-1';
import { inquiryAdminControllerDeleteV1 } from '../fn/inquiry-admin/inquiry-admin-controller-delete-v-1';
import { InquiryAdminControllerDeleteV1$Params } from '../fn/inquiry-admin/inquiry-admin-controller-delete-v-1';
import { inquiryAdminControllerFindByIdV1 } from '../fn/inquiry-admin/inquiry-admin-controller-find-by-id-v-1';
import { InquiryAdminControllerFindByIdV1$Params } from '../fn/inquiry-admin/inquiry-admin-controller-find-by-id-v-1';
import { inquiryAdminControllerSearchV1 } from '../fn/inquiry-admin/inquiry-admin-controller-search-v-1';
import { InquiryAdminControllerSearchV1$Params } from '../fn/inquiry-admin/inquiry-admin-controller-search-v-1';
import { InquiryDto } from '../models/inquiry-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class InquiryAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inquiryAdminControllerSearchV1()` */
  static readonly InquiryAdminControllerSearchV1Path = '/api/v1/inquiries/admin';

  /**
   * ���� ��� ��ȸ (������).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerSearchV1$Response(params: InquiryAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = inquiryAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ���� ��� ��ȸ (������).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerSearchV1(params: InquiryAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.inquiryAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `inquiryAdminControllerFindByIdV1()` */
  static readonly InquiryAdminControllerFindByIdV1Path = '/api/v1/inquiries/admin/{id}';

  /**
   * ���� �� ��ȸ (������).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerFindByIdV1$Response(params: InquiryAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
    const obs = inquiryAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ���� �� ��ȸ (������).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerFindByIdV1(params: InquiryAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<InquiryDto> {
    const resp = this.inquiryAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InquiryDto>): InquiryDto => r.body)
    );
  }

  /** Path part for operation `inquiryAdminControllerDeleteV1()` */
  static readonly InquiryAdminControllerDeleteV1Path = '/api/v1/inquiries/admin/{id}';

  /**
   * ���� ����.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerDeleteV1$Response(params: InquiryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ���� ����.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryAdminControllerDeleteV1(params: InquiryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `inquiryAdminControllerAnswerV1()` */
  static readonly InquiryAdminControllerAnswerV1Path = '/api/v1/inquiries/admin/{id}/answer';

  /**
   * ���� ���� ����.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryAdminControllerAnswerV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryAdminControllerAnswerV1$Response(params: InquiryAdminControllerAnswerV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryAdminControllerAnswerV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ���� ���� ����.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryAdminControllerAnswerV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryAdminControllerAnswerV1(params: InquiryAdminControllerAnswerV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryAdminControllerAnswerV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
